// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MenuBack: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10.479">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="m8.78 6.509-3.75 3.75a.746.746 0 0 1-1.06 0L.22 6.51a.75.75 0 1 1 1.06-1.06l2.47 2.47V.73c0-.415.336-.729.729-.729.393 0 .77.314.77.729v7.19L7.72 5.45a.75.75 0 1 1 1.06 1.06Z"
                opacity=".33"
            />
        </svg>
    );
};

export default React.memo(MenuBack);
